export const SHOW_DEMO_EVENTS = 'SHOW_DEMO_EVENTS'
export const SHOW_NO_EVENTS = 'SHOW_NO_EVENTS'
export const RESET_TO_LIVE_VIEW = 'RESET_TO_LIVE_VIEW'

export const showDemoEvents = () => ({type: SHOW_DEMO_EVENTS})
export const showNoEvents = (show: boolean) => ({type: SHOW_NO_EVENTS, payload: show})
